module.exports = __webpack_public_path__ + "static/media/cake.7351d6ec.png";